module.exports = "<body>\n  <div id=\"imagen\">\n    <img src=\"./assets/img_tigreRazones.png\" alt=\"\">\n  </div>\n  <div id=\"container\">\n    <h1>{{type}}</h1>\n    <h3>{{descripcion}}</h3>\n  </div>\n</body>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/errors/errors.component.html
// module id = ./src/app/errors/errors.component.html
// module chunks = main